export const invitesReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_INVITES_REQUEST":
      return {
        ...state,
        invites: null,
        loading: true,
      };

    case "GET_INVITES_SUCCESS":
      return {
        ...state,
        invites: action.payload,
        loading: false,
      };

    case "GET_INVITES_FAILED":
      return {
        ...state,
        invites: action.payload,
        loading: false,
      };
    case "GET_INVITE_REQUEST":
      return {
        ...state,
        invite: null,
        loading: true,
      };

    case "GET_INVITE_SUCCESS":
      return {
        ...state,
        invite: action.payload,
        loading: false,
      };

    case "GET_INVITE_FAILED":
      return {
        ...state,
        invite: action.payload,
        loading: false,
      };

    case "CHANGE_INVITE_REQUEST":
      return {
        ...state,
        invite: null,
        loading: true,
      };

    case "CHANGE_INVITE_SUCCESS":
      return {
        ...state,
        invite: action.payload,
        loading: false,
      };

    case "CHANGE_INVITE_FAILED":
      return {
        ...state,
        invite: action.payload,
        loading: false,
      };
      
    default:
      return state;
  }
};
